import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { short } from '../../common/formatting/date';
// import { fullname } from '../../common/formatting/provider';
import {
	loadProgramMembers, loadPracticePanel, loadAttributeGroups, loadCareQuestGroups, loadPatientAttributeGroupAssignments,
	loadPatientQuestionnaireGroupAssignments, deletePatientAttributeGroupAssignment, deleteQuestionnaireGroupAssignment,
	addPatientAttributeGroupAssignment, addQuestionnaireGroupAssignment, getPracticeProviders, updatePatientAttributeGroupAssignment
} from './api';
import AssignmentModal from './AssignmentModal';
import { Select } from '../../../../components';

export default class PracticePatientList extends Component {
	static propTypes = {
		user: PropTypes.object.isRequired,
		showNotification: PropTypes.func.isRequired,
	}

	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			isFiltering: false,
			isLoading: false,
			patients: [],
			attributeGroups: [],
			questionnaireGroups: [],
			connectedProviders: []
		};
	}

	componentDidMount() {
		const { provider_practice_id, id } = this.props.user;
		this.setState({ isLoading: true });
		Promise.all([
			loadPracticePanel(provider_practice_id),
			loadAttributeGroups(provider_practice_id),
			loadCareQuestGroups(provider_practice_id),
			getPracticeProviders(id)
		])
			.then(([patients, attributeGroups, questionnaireGroups, connectedProviders]) => {
				this.setState({
					patients,
					attributeGroups,
					questionnaireGroups,
					connectedProviders,
					isLoading: false
				});
			});
	}

	openModal = selectedPatientId => {
		const selectedPatient = this.state.patients.find(patient => patient.patientId === selectedPatientId);
		Promise.all([
			loadPatientAttributeGroupAssignments(this.props.user.provider_practice_id, selectedPatientId),
			loadPatientQuestionnaireGroupAssignments(this.props.user.provider_practice_id, selectedPatientId)
		])
			.then(([attributeGroupAssignments, questionnaireGroupAssignments]) => {
				this.setState({
					showModal: true,
					selectedPatient,
					attributeGroupAssignments,
					questionnaireGroupAssignments
				});
			});
	}

	closeModal = () => {
		this.setState({
			showModal: false
		});
	}

	handleSave = ({ attributeGroupSelections, questionnaireGroupSelections }) => {
		const {
			attributeGroupAssignments,
			questionnaireGroupAssignments,
			selectedPatient
		} = this.state;
		const { user } = this.props;
		const saveActions = [];
		Object.keys(attributeGroupSelections).forEach(agId => {
			const attributeAssignment = attributeGroupAssignments.find(assignment => assignment.providerPracticeProgramId == agId);
			if (attributeGroupSelections[agId] && attributeGroupSelections[agId].checked && !attributeAssignment) {
				saveActions.push(addPatientAttributeGroupAssignment({
					providerPracticeId: user.provider_practice_id,
					patientId: selectedPatient.patientId,
					providerPracticeProgramId: agId,
					providerId: attributeGroupSelections[agId].providerId
				}));
			}
			else if (attributeGroupSelections[agId] && attributeGroupSelections[agId].checked && attributeAssignment) {
				saveActions.push(updatePatientAttributeGroupAssignment({
					id: attributeAssignment.id,
					providerPracticeId: user.provider_practice_id,
					patientId: selectedPatient.patientId,
					providerPracticeProgramId: agId,
					providerId: attributeGroupSelections[agId].providerId || null
				}));
			}
			else if (attributeGroupSelections[agId] && !attributeGroupSelections[agId].checked && attributeAssignment) {
				saveActions.push(deletePatientAttributeGroupAssignment(attributeAssignment));
			}
		});
		Object.keys(questionnaireGroupSelections).forEach(qgId => {
			const questionnaireAssignment = questionnaireGroupAssignments.find(assignment => assignment.care_quest_groupId == qgId);
			if (questionnaireGroupSelections[qgId] && !questionnaireAssignment) {
				saveActions.push(addQuestionnaireGroupAssignment({
					providerPracticeId: user.provider_practice_id,
					patientId: selectedPatient.patientId,
					care_quest_groupId: qgId,
					// providerId: user.id
				}));
			}
			else if (!questionnaireGroupSelections[qgId] && questionnaireAssignment) {
				saveActions.push(deleteQuestionnaireGroupAssignment(questionnaireAssignment));
			}
		});
		Promise.all(saveActions)
			.then(() => {
				this.props.showNotification({
					status: 'success',
					message: 'All selections saved successfully'
				});
				this.setState({
					showModal: false
				});
			});
	}

	handleAttributeGroupFilterChange = ({ target }) => {
		if (target.value == -1) {
			this.setState({ patientFilter: null });
		} else {
			this.setState({ isFiltering: true });
			loadProgramMembers(target.value)
				.then(({ data }) => {
					this.setState({
						isFiltering: false,
						patientFilter: data.map(({ patientId }) => patientId)
					});
				});
		}
	}

	render() {
		const { isLoading, patients = [], attributeGroups, questionnaireGroups, connectedProviders } = this.state;
		const { showModal, selectedPatient, attributeGroupAssignments, questionnaireGroupAssignments, patientFilter, isFiltering } = this.state;

		const agFilterOptions = [
			{ value: -1, label: 'All Attribute Groups' }
		];
		if (attributeGroups) {
			agFilterOptions.push(
				...attributeGroups.map(({ id, program_name }) => ({ value: id, label: program_name }))
			);
		}

		let patientList = [...patients];
		if (patientFilter) {
			patientList = patients.filter(({ patientId }) => patientFilter.includes(patientId));
		}

		return (
			<div>
				<AssignmentModal
					isOpen={showModal}
					patient={selectedPatient}
					onCancel={this.closeModal}
					onSave={this.handleSave}
					attributeGroups={attributeGroups}
					questionnaireGroups={questionnaireGroups}
					attributeGroupAssignments={attributeGroupAssignments}
					questionnaireGroupAssignments={questionnaireGroupAssignments}
					connectedProviders={connectedProviders}
				/>
				<div className="row">
					<div className="col-md-4 col-md-offset-8">
						<Select
							options={agFilterOptions}
							onChange={this.handleAttributeGroupFilterChange}
						/>
					</div>
				</div>
				<table className="table table-hover">
					<thead>
						<tr>
							<th>Last Name</th>
							<th>First Name</th>
							<th>Date of Birth</th>
							{/* <th>Connected Provider</th> */}
						</tr>
					</thead>
					<tbody>
						{(isLoading || isFiltering) && (
							<tr>
								<td colSpan="3">Loading data...</td>
							</tr>
						)}
						{(!isLoading && !isFiltering && patientList.length > 0) && patientList.map(patient => (
							<tr key={patient.patientId} className="clickable" onClick={() => this.openModal(patient.patientId)}>
								<td>{patient.patient_name_last}</td>
								<td>{patient.patient_name_first}</td>
								<td>{short(patient.patient_dob)}</td>
								{/* <td>{patient.providerId && `${fullname({ name_last: patient.provider_name_last, name_first: patient.provider_name_first, credentials: patient.provider_credentials, name_middle: patient.provider_name_middle })}`}</td> */}
							</tr>
						))}
						{(!isLoading && !isFiltering && patientList.length === 0) && (
							<tr>
								<td colSpan="3">No patients found</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		);
	}
}
